/**
 * Users page (TRIAG-427) — profile URLs.
 *
 * `useParams()` (react-router 7.15) already returns the DECODED segment:
 * `matchRoutes` runs `decodePath` (per-segment decodeURIComponent, decoded
 * "/" kept as "%2F") and `matchPath` turns "%2F" back into "/". Never
 * decodeURIComponent a route param again: a username containing "%" would
 * throw URIError and crash the page.
 */

/** "." and ".." are URL navigation segments — react-router's
 *  resolvePathname and the browser's URL parser (even as %2E%2E) collapse
 *  them — so they can't be a profile path. Send them to the search page. */
const DOT_SEGMENTS = new Set([".", ".."]);

export function userHref(username: string): string {
  if (DOT_SEGMENTS.has(username)) {
    return `/users?q=${encodeURIComponent(username)}`;
  }
  return `/users/${encodeURIComponent(username)}`;
}

/** Decode one RAW path segment (from `location.pathname`, e.g. for the tab
 *  title). A malformed escape (a pasted "100%real") comes back unchanged
 *  instead of throwing. */
export function decodePathSegment(segment: string): string {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}
